import { createSlice } from '@reduxjs/toolkit';

import { customFormSidebarSlice } from './customFormSidebar';
import { inspectorSlice } from './inspector';
import { authSlice } from './slices/auth';
import { drawerSlice } from './slices/drawer';
import { globalErrorSlice } from './slices/global-error';
import { notificationsSlice } from './slices/notifications';
import { outboundDialIntentSlice } from './slices/outbound-dial-intent';
import { personalFilterViewSlice } from './slices/personal-filter-view';
import { selectedPatientSlice } from './slices/selected-patient';
import { selectedRoleSlice } from './slices/selected-role';
import { selectedVisitSlice } from './slices/selected-visit';
import { sidebarSlice } from './slices/sidebar';
import { testOverlaySlice } from './slices/test-overlay';
import { timezoneNagSlice } from './slices/timezone-nag';
import { totalVisitsSlice } from './slices/total-visits';
import { formSlice } from './slices/unsaved-changes';
import { patientsViewSlice } from './slices/views/patients';
import { queueViewSlice } from './slices/views/queue';
import { schedulingViewSlice } from './slices/views/scheduling';
import { visitHistoryViewSlice } from './slices/views/visitHistory';
import { waitingRoomSlice } from './slices/waiting-room';

export { createSlice };
export const { selectRole, clearSelectedRole } = selectedRoleSlice.actions;
export const { selectPatient, clearSelectedPatient } =
  selectedPatientSlice.actions;
export const { selectSegment } = waitingRoomSlice.actions;
export const { setGlobalError, clearGlobalError } = globalErrorSlice.actions;
export const { setTestModeOverlayVisible } = testOverlaySlice.actions;
export const { setAuthToken } = authSlice.actions;
export const { updateTotalVisits } = totalVisitsSlice.actions;
export const { toggleDrawer, setDrawerOpen } = drawerSlice.actions;
export const { setTimezoneNag } = timezoneNagSlice.actions;
export const {
  setHasUnsavedChanges,
  setShowUnsavedChangesDialog,
  resetHasUnsavedChanges,
  setPendingNavigationRoute,
} = formSlice.actions;
export const {
  setPfvArrived,
  setPfvReady,
  selectPfv,
  clearPfv,
  selectProvider,
  clearStatusFilters,
  clearProviderFilters,
  toggleFieldVisibility,
  setInitialColumnsVisibility,
  setColumnsVisibility,
  setGridDensity,
  setSortBy,
  setColumnsProps,
  setWRColumnFiltering,
  setWRColumnSorting,
  setPatientDetailsDisplayField,
  resetToDefault,
  updatePfvCounts,
} = personalFilterViewSlice.actions;
export const {
  selectVisit,
  clearSelectedVisit,
  setVisitPreferredPharmacy,
  setVisitPractice,
} = selectedVisitSlice.actions;
export const {
  setSidebarPage,
  openSidebar,
  closeSidebar,
  openQtcSidebar,
  displayBack,
  backBtnClicked,
} = sidebarSlice.actions;
export const {
  addCustomFormNotification,
  clearCustomFormNotification,
  clearAllCustomFormNotifications,
  setCustomFormToastActionEvent,
} = notificationsSlice.actions;

export const {
  openCustomFormSidebar,
  partialClearCustomFormSidebar,
  clearCustomFormSidebar,
  updateDirtyState,
  updateKeepLock,
} = customFormSidebarSlice.actions;

export const {
  appendConsoleLine,
  toggleConsole,
  toggleGroupFeaturesSettings,
  toggleConsoleLogErrors,
  toggleAttachConsoleLog,
  setLastSearch,
} = inspectorSlice.actions;

export const { setOutboundDialIntent, clearOutboundDialIntent } =
  outboundDialIntentSlice.actions;

const slices = {
  [selectedPatientSlice.name]: selectedPatientSlice.reducer,
  [waitingRoomSlice.name]: waitingRoomSlice.reducer,
  [totalVisitsSlice.name]: totalVisitsSlice.reducer,
  [globalErrorSlice.name]: globalErrorSlice.reducer,
  [testOverlaySlice.name]: testOverlaySlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [drawerSlice.name]: drawerSlice.reducer,
  [personalFilterViewSlice.name]: personalFilterViewSlice.reducer,
  [selectedVisitSlice.name]: selectedVisitSlice.reducer,
  [sidebarSlice.name]: sidebarSlice.reducer,
  [patientsViewSlice.name]: patientsViewSlice.reducer,
  [schedulingViewSlice.name]: schedulingViewSlice.reducer,
  [visitHistoryViewSlice.name]: visitHistoryViewSlice.reducer,
  [queueViewSlice.name]: queueViewSlice.reducer,
  [timezoneNagSlice.name]: timezoneNagSlice.reducer,
  [formSlice.name]: formSlice.reducer,
  [selectedRoleSlice.name]: selectedRoleSlice.reducer,
  [notificationsSlice.name]: notificationsSlice.reducer,
  [customFormSidebarSlice.name]: customFormSidebarSlice.reducer,
  [inspectorSlice.name]: inspectorSlice.reducer,
  [outboundDialIntentSlice.name]: outboundDialIntentSlice.reducer,
};

export default slices;
